(function (Drupal) {
  Drupal.behaviors.header = {
    attach: function (context) {
      let headerIsFull = true;
      let ready = true;

      const header = document.querySelector("header");
      const donateButton = document.querySelector("#ccc-header-donate");

      function hasScrolled() {
        let distance = window.scrollY;

        if (distance >= 140 && headerIsFull) {
          ready = false;
          header.classList.add("ccc-header--compact");
          header.classList.remove("ccc-header--full");
          donateButton.classList.remove("ccc-button--big");
          donateButton.style.textTransform = "uppercase";
          headerIsFull = false;
        } else if (distance < 140 && !headerIsFull) {
          ready = false;
          header.classList.remove("ccc-header--compact");
          header.classList.add("ccc-header--full");
          donateButton.classList.add("ccc-button--big");
          headerIsFull = true;
        }

        setTimeout(() => {
          ready = true;
        }, 500);
      }

      document.addEventListener(
        "scroll",
        function () {
          if (ready) {
            hasScrolled();
          }
        },
        { passive: true }
      );
    },
  };
})(Drupal);